import React from 'react';
import '../scss/ConfirmModal.scss';

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <p>{message}</p>
        <div className="confirm-modal-buttons">
          <button onClick={onCancel}>Avbryt</button>
          <button onClick={onConfirm}>Ta bort</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
